import React from 'react'
import { RouteComponentProps, Route, Switch } from 'react-router-dom'

import { EventEditPage } from './event-edit/EventEditPage'
import { ManageEventsPage } from './event-list/ManageEventsPage'

import './ManageEvents.less'

type ManageEventsProps = RouteComponentProps<Record<string, string>>

export const ManageEventsPageWrapper = ({
  match: { url }
}: ManageEventsProps) => (
  <Switch>
    <Route
      exact
      path={`${url}/:eventId/:tab(attendance)?`}
      component={EventEditPage}
    />
    <Route
      exact
      path={`${url}/:eventId/series/:tab(occurrences|attendance)?`}
      component={EventEditPage}
    />
    <Route exact path={`${url}/`} component={ManageEventsPage} />
  </Switch>
)
